export { default as PickingBatchListTemplate } from './PickingBatchListTemplate';
export { default as PickingBatchListDetailTemplate } from './PickingBatchListDetailTemplate';



// WEBPACK FOOTER //
// ./src/themes/default/modules/picking-batch/pages/index.js